import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DevExtremeModule} from '../devextreme.module';
import {AdjustmentPricingGridComponent} from './adjustment-pricing-grid.component';
import {OptionsCommonModule} from '../options-common/options-common.module';
import {AgGridModule} from 'ag-grid-angular';
import {EtsSymbolPickerModule} from '../symbol-picker/symbol-picker.module';
import {LastPriceModule} from '../last-price/last-price.module';
import {AdjustmentPricingGridPanelComponent} from './panel/adjustment-pricing-grid-panel.component';
import {
    CashFlowStrategySettingsComponent
} from './settings-section/cash-flow-strategy-settings/cash-flow-strategy-settings.component';
import {AdjustmentGridSettingsSectionComponent} from './settings-section/adjustment-grid-settings-section.component';
import {
    AdjustmentGridGlobalSettingsComponent
} from './settings-section/global-settings/adjustment-grid-global-settings.component';
import {
    AdjustmentGridExpirationsSettingsComponent
} from './settings-section/expirations-settings/adjustment-grid-expirations-settings.component';
import {AdjustmentGridPositionsStateComponent} from './popup/positions/adjustment-grid-positions-state.component';
import {AdjustmentGridOrdersComponent} from './popup/orders/adjustment-grid-orders.component';
import {
    AdjustmentPricingGridPositionsSectionComponent
} from './positions-section/adjustment-pricing-grid-positions-section.component';
import {BeforeStatePopupDefaultsHeaderComponent} from './positions-section/before-state-defaults-header.component';
import {AdjustmentComparisonGridPanelComponent} from './panel/adjustment-comparison-grid-panel.component';
import {MarketTimeModule} from '../market-time/market-time.module';
import {ApgChecklistComponent} from './popup/checklist/apg-checklist.component';
import {AllowStylesPipe} from './popup/checklist/allow-styles.pipe';
import {AdjustmentSolutionPopupComponent} from './solution-popup/adjustment-solution-popup.component';
import {ApgAfterStatePreviewComponent} from './after-state-preview/apg-after-state-preview.component';
import {ApgPortfolioRefreshDialogComponent} from './portfolio-refresh-dialog/apg-portfolio-refresh-dialog.component';
import {SweetPriceTrackingService} from './services/sweet-price-tracking.service';
import {ApgTrackingDialogComponent} from './positions-section/tracking-dialog/apg-tracking-dialog.component';
import {DateTimePickerModule} from '../datetime-picker/datetime-picker.module';
import {TimezonePickerModule} from '../timezone-picker/timezone-picker.module';
import {
    ApgTrackingSyncDialogComponent
} from './positions-section/tracking-sync-dialog/apg-tracking-sync-dialog.component';
import {AssignableAdjustmentTemplatesService} from './settings-section/assignable-adjustment-templates.service';
import {DynamicOffsetsButtonComponent} from './positions-section/dynamic-offsets/dynamic-offsets-button.component';
import {GenericConfirmationDialogModule} from '../generic-confirmation-dialog/generic-confirmation-dialog.module';
import {ApgContextMenuComponent} from "./context-menu/apg-context-menu.component";
import {VisibleOffsetsComponent} from "./visible-offsets/visible-offsets.component";
import {VisibleOffsetsSettingsService} from "./visible-offsets/visible-offsets-settings.service";
import {PriceboxMenuComponent} from "./pricebox-menu/pricebox-menu.component";
import {IsValidNumberPipe} from "../common-services/is-valid-number.pipe";
import {AfterStateDetalizationComponent} from "./after-state-detalization/after-state-detalization.component";
import {PriceboxCellComponent} from "./pricebox-cell/pricebox-cell.component";
import {StrategiesCellComponent} from "./strategies-cell/strategies-cell.component";
import {ZonesGridSettingsComponent} from "./zones-grid-settings/zones-grid-settings.component";
import {ZonesGridComponent} from "./zones-grid/zones-grid.component";
import {ZonesGridCellComponent} from "./zones-grid/zones-grid-cell/zones-grid-cell.component";
import {ZonesGridMenuComponent} from "./zones-grid-menu/zones-grid-menu.component";
import {ApgSectionVisibilityMenuComponent} from "./section-visibility-menu/apg-section-visibility-menu.component";
import {VolatilityHeaderComponent} from "./volatility-header/volatility-header.component";
import {ApgPricingStepsPopupComponent} from "./apg-pricing-steps-popup/apg-pricing-steps-popup.component";
import {EtsCommonModule} from "../common-services/common.module";
import {ApgHedgesTotalComponent} from "./hedges-total/apg-hedges-total.component";
import {HedgingGridModule} from "../hedging-grid/hedging-grid.module";
import {OverrideAtmDialogModule} from "../override-atm-dialog/override-atm-dialog.module";
import {
    PauseNotificationsComponent
} from "./positions-section/tracking-dialog/pause-notifications/pause-notifications.component";
import {OrdersRegroupModule} from "../orders-regroup-dialog/orders-regroup.module";
import {HedgesTotalSweetPriceComponent} from "./positions-section/tracking-dialog/hedges-total-sweet-price/hedges-total-sweet-price.component";
import {ExpirationSelectorModule} from "../expiration-selector/expiration-selector.module";
import {ApgCopilotComponent} from "./copilot/apg-copilot.component";
import {ApgCopilotTabBarComponent} from "./copilot/apg-copilot-tab-bar.component";
import {ApgCopilotBreadcrumbBarComponent} from "./copilot/apg-copilot-breadcrumb-bar.component";
import {ApgRollPositionsPanelComponent} from "./copilot/apg-roll-positions-panel.component";
import {ApgExclusionCalendarComponent} from "./copilot/apg-exclusion-calendar.component";
import {ApgZonePanelComponent} from "./copilot/apg-zone-panel.component";
import {ApgCopilotResultsListComponent} from "./copilot/apg-copilot-results-list.component";
import {ApgCopilotSnippetCardComponent} from "./copilot/apg-copilot-snippet-card.component";
import {ROLL_POSITIONS_SKILL} from "./copilot/apg-roll-positions-skill";
import {BackendApgOrionSkill} from "./copilot/backend-apg-orion-skill";
import {EtsDraggableModule} from "../draggable/ets-draggable.module";
import {EtsFitToViewportModule} from "../fit-to-viewport/ets-fit-to-viewport.module";
import {LandmineDaysService} from "./services/landmine-days.service";

@NgModule({
    declarations: [
        AdjustmentPricingGridComponent,
        AdjustmentPricingGridPanelComponent,
        AdjustmentComparisonGridPanelComponent,

        AdjustmentGridSettingsSectionComponent,
        AdjustmentGridGlobalSettingsComponent,
        AdjustmentGridExpirationsSettingsComponent,
        CashFlowStrategySettingsComponent,
        AdjustmentGridPositionsStateComponent,
        AdjustmentGridOrdersComponent,
        AdjustmentPricingGridPositionsSectionComponent,
        BeforeStatePopupDefaultsHeaderComponent,
        ApgChecklistComponent,
        AllowStylesPipe,
        AdjustmentSolutionPopupComponent,
        ApgAfterStatePreviewComponent,
        ApgPortfolioRefreshDialogComponent,
        ApgTrackingDialogComponent,
        ApgTrackingSyncDialogComponent,
        DynamicOffsetsButtonComponent,
        ApgContextMenuComponent,
        VisibleOffsetsComponent,
        PriceboxMenuComponent,
        AfterStateDetalizationComponent,
        PriceboxCellComponent,
        StrategiesCellComponent,
        ZonesGridSettingsComponent,
        ZonesGridComponent,
        ZonesGridCellComponent,
        ZonesGridMenuComponent,
        ApgSectionVisibilityMenuComponent,
        VolatilityHeaderComponent,
        ApgHedgesTotalComponent,
        PauseNotificationsComponent,
        HedgesTotalSweetPriceComponent,
        ApgPricingStepsPopupComponent,

        // APG CoPilot (advisory roll-positions assistant; entitlement-gated, purely additive)
        ApgCopilotComponent,
        ApgCopilotTabBarComponent,
        ApgCopilotBreadcrumbBarComponent,
        ApgRollPositionsPanelComponent,
        ApgExclusionCalendarComponent,
        ApgZonePanelComponent,
        ApgCopilotResultsListComponent,
        ApgCopilotSnippetCardComponent
    ],

    imports: [
        EtsCommonModule,
        CommonModule,
        DevExtremeModule,
        OptionsCommonModule,
        EtsSymbolPickerModule,
        LastPriceModule,
        AgGridModule.withComponents([]),
        MarketTimeModule,
        DateTimePickerModule,
        TimezonePickerModule,
        GenericConfirmationDialogModule,
        HedgingGridModule,
        OverrideAtmDialogModule,
        OrdersRegroupModule,
        ExpirationSelectorModule,
        EtsDraggableModule,
        EtsFitToViewportModule
    ],

    exports: [
        AdjustmentPricingGridComponent,
        AdjustmentPricingGridPanelComponent,
        AdjustmentComparisonGridPanelComponent,
        AdjustmentSolutionPopupComponent,
        CashFlowStrategySettingsComponent,
        AllowStylesPipe,
        IsValidNumberPipe,
        ApgHedgesTotalComponent,

        // CR-20260910-001 (leader ruling L21): the ORION questionnaire's two controls, EXPORTED so
        // another module can reuse them. They were declared here and never exported, which made the
        // Date Range questionnaire un-reusable outside this module even though it was written to be
        // reused. Maven's Setup is the first consumer.
        ApgRollPositionsPanelComponent,
        ApgExclusionCalendarComponent
    ],

    providers: [
        SweetPriceTrackingService,
        AssignableAdjustmentTemplatesService,
        VisibleOffsetsSettingsService,

        // The Events Calendar (CR-20260904-001, contract C1): the SINGLE fetch point for landmine
        // days, shared by ORION's filtering and the Price Box colouring. Panel-scoped, so its
        // 15-minute span cache lives and dies with the APG panel instance.
        LandmineDaysService,

        // The Roll Positions skill seam. CR-20260910-001 milestone 1 swapped the BROWSER skill for
        // the BACKEND CLIENT: the run is sent as RunApgOrionSkill and its cards arrive on the event
        // stream. There is no DI alternative to flip to any more - the mock scoring brain was deleted
        // with the real one, because a stand-in for a wire call is a stubbed transport, not a second
        // set of rules nobody exercises.
        //
        // MODULE-SCOPED, so ONE client serves both inner grids of an Adjustment Comparison Grid. Its
        // pending runs are keyed by runId and supersede is scoped to (terminalId, panelInstanceId),
        // so the two panels cannot displace each other's runs.
        { provide: ROLL_POSITIONS_SKILL, useClass: BackendApgOrionSkill }
    ]
})
export class AdjustmentPricingGridModule {
}
